import { createSelector } from 'reselect';

const orderState = (state) => state.order;

export const getCart = createSelector(orderState, (state) => state.cart);

export const getCartId = createSelector(orderState, (state) => state.cartId);
